import './styles/liquid-glass.css';
import { LiquidGlassElement } from './components/liquid-glass';
import { LiquidButtonElement } from './components/liquid-button';
import { LiquidCardElement } from './components/liquid-card';
import { LiquidGlassControlsElement } from './components/liquid-glass-controls';

export * from './types';
export * from './core/svg-engine';
export * from './core/webgl-engine';
export { LiquidGlassElement } from './components/liquid-glass';
export { LiquidButtonElement } from './components/liquid-button';
export { LiquidCardElement } from './components/liquid-card';
export { LiquidGlassControlsElement } from './components/liquid-glass-controls';

export class LiquidContainerElement extends LiquidGlassElement {}

export function registerLiquidGlass() {
  if (typeof window !== 'undefined' && 'customElements' in window) {
    if (!customElements.get('liquid-glass')) {
      customElements.define('liquid-glass', LiquidGlassElement);
    }
    if (!customElements.get('liquid-container')) {
      customElements.define('liquid-container', LiquidContainerElement);
    }
    if (!customElements.get('liquid-button')) {
      customElements.define('liquid-button', LiquidButtonElement);
    }
    if (!customElements.get('liquid-card')) {
      customElements.define('liquid-card', LiquidCardElement);
    }
    if (!customElements.get('liquid-glass-controls')) {
      customElements.define('liquid-glass-controls', LiquidGlassControlsElement);
    }
  }
}

// Auto-register when imported directly via script tag or bundler in browser
if (typeof window !== 'undefined') {
  registerLiquidGlass();
}
